"use strict";
/**
 * @fileoverview Shader attributes module.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mat4Attribute = exports.Mat3Attribute = exports.Mat2Attribute = exports.Vec4Attribute = exports.Vec3Attribute = exports.Vec2Attribute = exports.FloatAttribute = exports.Attribute = void 0;
const gl_1 = require("./gl");
/**
 * Abstraction for sending data to shaders in attributes.
 */
class Attribute {
    constructor(name_, dimension_, data_) {
        this.name_ = name_;
        this.dimension_ = dimension_;
        this.data_ = data_;
        if (Array.isArray(this.data_) && !isNaN(this.data_[0])) {
            this.data_ = new Float32Array(this.data_);
        }
    }
    /**
     * Send the attribute data to the shader.
     */
    send(gl, program) {
        if (!this.buffer_)
            this.buffer_ = gl.createBuffer();
        gl_1.sendAttribute(gl, program, this.buffer_, this.name_, this.data_, this.dimension_);
    }
    /**
     * Get the number of vertices that will be sent to the shader.
     * This is only used if the shader is using gl.drawArrays(...).
     */
    length() {
        if (this.data_ instanceof Float32Array) {
            let result = this.data_.byteLength / this.data_.BYTES_PER_ELEMENT;
            result /= this.dimension_;
            return result;
        }
        else {
            return this.data_.length / this.dimension_;
        }
    }
}
exports.Attribute = Attribute;
/**
 * Returns an attribute builder function for the appropriate type.
 */
const attribute = (dimension) => (name, data) => new Attribute(name, dimension, data);
/**
 * Sends a float attribute to a shader.
 * @param name of the attribute in the shader
 * @param data the attribute will send
 */
exports.FloatAttribute = attribute(1);
/**
 * Sends a 2-dimensional vector attribute to a shader.
 * @param name of the attribute in the shader
 * @param data the attribute will send
 */
exports.Vec2Attribute = attribute(2);
/**
 * Sends a 3-dimensional vector attribute to a shader.
 * @param name of the attribute in the shader
 * @param data the attribute will send
 */
exports.Vec3Attribute = attribute(3);
/**
 * Sends a 4-dimensional vector attribute to a shader.
 * @param name of the attribute in the shader
 * @param data the attribute will send
 */
exports.Vec4Attribute = attribute(4);
/**
 * Abstraction for sending a matrix attribute to a shader.
 */
class MatrixAttribute extends Attribute {
    constructor(name, dimension, data) {
        super(name, dimension, data);
        if (Array.isArray(data[0]) && Array.isArray(data[0][0])) {
            this.data_ = this.data_.map((arr) => new Float32Array(arr));
        }
    }
    /**
     * Send the data to the shader.
     */
    send(gl, program) {
        if (!this.buffer_)
            this.buffer_ = gl.createBuffer();
        gl_1.sendMatrixAttribute(gl, program, this.buffer_, this.name_, this.data_, this.dimension_);
    }
}
/**
 * Returns a matrix attribute builder function for the appropriate type.
 */
const matrixAttribute = (dimension) => (name, data) => new MatrixAttribute(name, dimension, data);
/**
 * Sends a 2-dimensional matrix attribute to a shader.
 * @param name of the attribute in the shader
 * @param data the attribute will send
 */
exports.Mat2Attribute = matrixAttribute(2);
/**
 * Sends a 3-dimensional matrix attribute to a shader.
 * @param name of the attribute in the shader
 * @param data the attribute will send
 */
exports.Mat3Attribute = matrixAttribute(3);
/**
 * Sends a 4-dimensional matrix attribute to a shader.
 * @param name of the attribute in the shader
 * @param data the attribute will send
 */
exports.Mat4Attribute = matrixAttribute(4);
